import WeightItem from './WeightItem';

export default WeightItem;
